// Helpers for the "Academic Year" field used in the Academics CMS + public Academics page.
// Academic year runs from June (month 5, zero-indexed) → May (month 4) of the following year.
// Format: "YYYY-YY" (e.g. "2025-26").

export function computeAcademicYear(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth(); // 0 = Jan, 5 = Jun
  const start = m >= 5 ? y : y - 1;
  const end = start + 1;
  return `${start}-${String(end).slice(-2)}`;
}

/**
 * Returns dropdown options around the current academic year.
 *   - Includes 5 past, current, and 1 future AY by default.
 *   - Sorted descending (newest first).
 */
export function academicYearOptions({ past = 5, future = 1, date = new Date() } = {}) {
  const current = computeAcademicYear(date);
  const startYear = parseInt(current.split("-")[0], 10);
  const out = [];
  for (let i = future; i >= -past; i--) {
    const s = startYear + i;
    const e = s + 1;
    out.push(`${s}-${String(e).slice(-2)}`);
  }
  return out; // newest → oldest
}
